import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { Link } from "react-router-dom";
import Pagination from "../../components/Pagination";
import DeleteConfirmation from "../../components/DeleteConfirmation";
import { bookingService } from "../../services/bookingService";
import { params } from "../../config/params";
import { searchParams } from "../../config/searchParams";
import Loading from "../../components/common/Loading";
import { toast } from "../../services/toastService";
import InLinneLoading from "../../components/common/InlineLoading";
import StatusConfirmation from "../../components/StatusConfirmation";

const Bookings = () => {
  const { t, lang } = useContext(LocaleContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loadingId, setLoadingId] = useState(null);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);

  useEffect(() => {
    defaulLoad();
  }, []);



  const defaulLoad = async () => {
    setLoading(true);
    getAllAsync();
  };

  const getAllAsync = async () => {
    try {
      var data = await bookingService.getAllAsync(params);
      if (!data.isSuccess) {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log(data);
        return;
      }
      setData(data.value);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const getAllSearchAsync = async (signal) => {
    try {
      var data = await bookingService.getAllSearchAsync(searchParams, signal);
      setData(data.value);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  // 🟢 Search effect with debounce & cancel
  useEffect(() => {
    if (search.trim().length < 2) {
      params.pageNumber = 1;
      getAllAsync(); // reset to default if search is cleared
      return;
    }

    const controller = new AbortController(); // cancel token
    const delay = setTimeout(() => {
      searchParams.search = search.trim(); // update global params
      searchParams.pageNumber = 1; // reset page to 1 on search
      getAllSearchAsync(controller.signal);
    }, 400); // debounce time

    return () => {
      controller.abort(); // cancel previous request
      clearTimeout(delay); // clear debounce
    };
  }, [search]);
  const onPageChange = async (pageNumber) => {
    setLoading(true);
    if (!search) {
      params.pageNumber = pageNumber;
      getAllAsync();
      return;
    }
    searchParams.pageNumber = pageNumber;
    await getAllSearchAsync();
  };
  const allowedStatusTransitions = {
    WaitingForApproval: ["WaitingForPayment", "Declined"],

    WaitingForPayment: ["Paid", "Declined", "Incomplete"],

    Paid: ["Cancelled", "Incomplete"],

    CustomerCompleted: ["FullyCompleted"],

    ProviderCompleted: ["FullyCompleted"],

    Declined: [],

    Cancelled: [],

    Incomplete: ["WaitingForPayment", "Cancelled"],

    FullyCompleted: [],
  };
  const confirmationStatuses = [
    "Paid",
    "Declined",
    "Cancelled",
    "FullyCompleted",
  ];
  const requestStatusChange = (bookingId, newStatus) => {
    if (confirmationStatuses.includes(newStatus)) {
      setPendingStatusChange({
        bookingId,
        newStatus,
      });

       document.getElementById("status-confirmation-trigger")?.click();

      return;
    }

    handleStatusChange(bookingId, newStatus);
  };
  const confirmStatusChange = () => {
    if (!pendingStatusChange) return;

    handleStatusChange(
      pendingStatusChange.bookingId,
      pendingStatusChange.newStatus,
    );

    setPendingStatusChange(null);
  };
  const handleStatusChange = async (bookingId, newStatus) => {
    try {
      setLoadingId(bookingId);
      var data = await bookingService.updateStatus(bookingId, newStatus);

      if (!data.isSuccess) {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log(data);
        return;
      }
      setData((prev) => ({
        ...prev,
        items: prev.items.map((item) =>
          item.id === bookingId ? { ...item, status: newStatus } : item,
        ),
      }));
      toast.success(t("recordUpdatedSuccessfully"));
    } catch (error) {
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      console.log(error);
    } finally {
      setLoadingId(null);
    }
  };

  if (loading) return <Loading />;
  return (
    <>
      <section className="section-bookings">
        <div className="default-heading">{t("bookings")}</div>
        <section className="section-dashboard-cards mb-3 d-none">
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="d-card d-card-primary">
                <div className="d-card-header">{t("totalUsers")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-dark">
                <div className="d-card-header">{t("onlineUsers")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-primary">
                <div className="d-card-header">{t("client")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-dark">
                <div className="d-card-header">{t("totalRevenue")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-grid">
          <div className="grid-card">
            <div className="grid-card-header">
              <strong>{t("bookingsManagement")}</strong>
              <p>{t("viewAndManageAllBookingsInTheSystem")}</p>
            </div>
            <div className="grid-card-body">
              <div className="table-header">
                <div className="table-header-icons hidden">
                  <div className="icon-box">
                    <i className="fas fa-file-pdf"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-file-excel"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-print"></i>
                  </div>
                </div>
                <div className="table-search">
                  <div className="input-icon input-icon-width">
                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control input-search"
                      placeholder={t("search")}
                    />
                    <i className="fas fa-search"></i>
                  </div>
                  <div className="grid-btn">
                    <Link to="/booking-form">
                      <button className="btn-default my-bg-secondary">
                        <i className="fas fa-plus"></i> {t("addNewBooking")}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-delete-option mt-3">
                <b>{t("allBookings")}</b>
                <div className="dropdown d-none">
                  <i
                    className="fas fa-filter cursor-pointer"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  />
                  <span></span>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("status")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("trip")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("city")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("date")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="my-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <input type="checkbox" />
                      </th>
                      <th>{t("code")}</th>
                      <th>{t("userName")}</th>
                      <th>{t("trip")}</th>
                      <th>{t("provider")}</th>
                      <th>{t("city")}</th>
                      <th>{t("status")}</th>
                      <th>{t("cost")}</th>
                      <th>{t("startTime")}</th>
                      <th>{t("date")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.items?.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td>{item.code}</td>
                        <td>{item.customerName}</td>
                        <td>{item.title[lang]}</td>
                        <td>{item.provider}</td>
                        <td>{item.city[lang]}</td>
                        <td>
                          {loadingId === item.id && <InLinneLoading />}
                          {loadingId !== item.id && (
                            <select
                              className={`form-control status-${item.status}`}
                              value={item.status}
                              onChange={(e) =>
                                requestStatusChange(item.id, e.target.value)
                              }
                            >
                              {[
                                item.status,
                                ...(allowedStatusTransitions[item.status] ||
                                  []),
                              ]
                                .filter(
                                  (status, index, statuses) =>
                                    statuses.indexOf(status) === index,
                                )
                                .map((status) => (
                                  <option
                                    key={status}
                                    value={status}
                                    className={`status-${status}`}
                                  >
                                    {t(status)}
                                  </option>
                                ))}
                            </select>
                          )}
                        </td>
                        <td>
                          {item.totalCost} {t("riyal")}
                        </td>
                        <td>{item.startTime?.toTime()}</td>
                        <td>{item.startDate?.toDate()}</td>
                        <td>
                          <i
                            class="fas fa-ellipsis-vertical"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          ></i>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href={`/booking-form/${item.id}`}
                              >
                                <i className="fas fa-edit"></i> {t("edit")}
                              </a>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to={`/booking-details/${item.id}`}
                              >
                                <i className="fas fa-eye"></i> {t("view")}
                              </Link>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => e.preventDefault()}
                                data-bs-toggle="modal"
                                data-bs-target="#my-modal"
                              >
                                <i className="fas fa-trash-alt text-danger"></i>{" "}
                                {t("delete")}
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))}
                    {data?.items?.length === 0 && (
                      <tr>
                        <td colSpan="100%" className="text-center py-3">
                          {t("noResultsFound")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid-footer">
              {data && (
                <Pagination
                  t={t}
                  pageNumber={data.pageNumber}
                  totalPages={data.totalPages}
                  hasNextPage={data.hasNextPage}
                  hasPreviousPage={data.hasPreviousPage}
                  onPageChange={onPageChange}
                />
              )}
            </div>
          </div>
        </section>
      </section>
      <DeleteConfirmation t={t} />
      <StatusConfirmation
        t={t}
        currentStatus={
          data?.items?.find(
            (item) => item.id === pendingStatusChange?.bookingId,
          )?.status
        }
        status={pendingStatusChange?.newStatus}
        handleConfirm={confirmStatusChange}
      />
      <button
        id="status-confirmation-trigger"
        type="button"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#status-confirmation-modal"
      />
    </>
  );
};

export default Bookings;
